import Empty from 'constants/empty';
import { createSelector } from 'reselect';
import { beautyInsiderAccountSelector } from 'selectors/user/beautyInsiderAccount/beautyInsiderAccountSelector';

/**
 * Linked partner accounts from the member's Beauty Insider account — the same data
 * the Account Settings "linked accounts" section uses. Each entry includes
 * partnerName / partnerID. Returns a stable empty array when there are none.
 *
 * @returns {Array<Object>} Linked partner account details.
 */
const linkedAccountDetailsSelector = createSelector(
    beautyInsiderAccountSelector,
    beautyInsiderAccount => beautyInsiderAccount.linkedAccountDetails || Empty.Array
);

export { linkedAccountDetailsSelector };
